/* Shto chair buy box (sections/shto-chair-buy.liquid).
   - Three chairs: picking one (its card, its label on the first photo, or any [data-shto-chair="<key>"] link on the page)
     changes the colours, price, Total value, % off, Affirm amount and the sticky bar.
   - Colours are the chosen chair's variants; a sold-out one is disabled. Add To Cart: window.ShtoCart.add (assets/shto-cart.js).
   - Affirm: each chair has a hidden Affirm "as low as" element with its price. Affirm fills in its own monthly amount
     (.affirm-ala-price), which is copied into the card. Tapping the card opens Affirm's own learn-more pop-up.
   - Gallery: the main photo row scrolls sideways (assets/shto-swipe.js makes it swipeable); counter, thumbnails and arrows.
   - Colour photos (blocks "Colour photo", [data-shto-color-photos]): every load shows the gallery's own photos only, three-chairs
     photo first. Once the visitor clicks a colour, for the chairs in "Chairs with colour photos" that colour's photos come
     first, then the other photos. Picking another colour (or chair) swaps them and shows the first one; for any other chair
     (Pro) they are taken out and the gallery is as before.
   - Sticky bar: shown once the main Add To Cart has scrolled up off the screen, hidden again as soon as it comes back.
     Countdown kept per visitor in localStorage; when it reaches zero it starts again. The page address is never changed. */
(function () {
  if (window.ShtoChairBuy) return;
  window.ShtoChairBuy = true;

  function store(key, value) {
    try {
      if (value === undefined) return window.sessionStorage.getItem(key);
      window.sessionStorage.setItem(key, value);
    } catch (e) { return null; }
    return null;
  }

  function headerBottom() {
    var h = document.getElementById('shopify-section-header');
    if (!h) return 0;
    var pos = getComputedStyle(h).position;
    if (pos !== 'sticky' && pos !== 'fixed') return 0;
    return Math.max(0, h.getBoundingClientRect().bottom);
  }

  function init(root) {
    if (!root || root.shtoReady) return;
    root.shtoReady = true;
    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

    var chairs = {};
    $$('[data-shto-chair-data]').forEach(function (li) {
      chairs[li.getAttribute('data-shto-chair-data')] = {
        name: li.getAttribute('data-name'),
        price: li.getAttribute('data-price'),
        value: li.getAttribute('data-value'),
        pct: li.getAttribute('data-pct'),
        photo: li.getAttribute('data-photo'),
        affirm: li.querySelector('[data-shto-affirm-src]'),
        amount: '',
        variants: Array.prototype.map.call(li.querySelectorAll('li[data-id]'), function (v) {
          return { id: v.getAttribute('data-id'), color: v.getAttribute('data-color'), hex: v.getAttribute('data-hex'), available: v.getAttribute('data-available') === 'true' };
        })
      };
    });
    var offText = root.getAttribute('data-off-text') || '';
    var buttonText = root.getAttribute('data-button') || '';
    var soldOutText = root.getAttribute('data-sold-out') || '';
    var state = { chair: root.getAttribute('data-default'), variant: null };
    var firstSwatch = $('[data-shto-swatches] .shto-chair-buy__swatch.is-on');
    state.variant = firstSwatch ? firstSwatch.getAttribute('data-id') : null;

    function current() { return chairs[state.chair]; }
    function variant() {
      var c = current();
      if (!c) return null;
      for (var i = 0; i < c.variants.length; i++) if (c.variants[i].id === state.variant) return c.variants[i];
      return c.variants[0] || null;
    }
    function setText(sel, text) { $$(sel).forEach(function (el) { el.textContent = text; }); }

    function renderSwatches() {
      var wrap = $('[data-shto-swatches]');
      var c = current();
      if (!wrap || !c) return;
      wrap.innerHTML = '';
      c.variants.forEach(function (v, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'shto-chair-buy__swatch' + (v.id === state.variant ? ' is-on' : '');
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', v.id === state.variant ? 'true' : 'false');
        b.setAttribute('aria-label', v.color + (v.available ? '' : ' (' + soldOutText + ')'));
        b.setAttribute('data-id', v.id);
        b.setAttribute('data-color', v.color);
        b.setAttribute('data-shto', 'swatch-' + (i + 1));
        b.style.setProperty('--shto-swatch', v.hex);
        if (!v.available) b.disabled = true;
        wrap.appendChild(b);
      });
    }

    function update() {
      var c = current(), v = variant();
      if (!c) return;
      $$('[data-shto-card]').forEach(function (card) {
        var on = card.getAttribute('data-shto-card') === state.chair;
        card.classList.toggle('is-on', on);
        card.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      $$('.shto-chair-buy__label[data-shto-chair]').forEach(function (l) { l.classList.toggle('is-on', l.getAttribute('data-shto-chair') === state.chair); });
      $$('[data-shto-swatches] .shto-chair-buy__swatch').forEach(function (s) {
        var on = s.getAttribute('data-id') === state.variant;
        s.classList.toggle('is-on', on);
        s.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      setText('[data-shto-color-name]', v ? v.color : '');
      setText('[data-shto-price]', c.price);
      var hasValue = !!(c.value && c.pct);
      setText('[data-shto-value]', hasValue ? c.value : '');
      setText('[data-shto-off]', hasValue ? offText.replace('[percent]', c.pct) : '');
      $$('[data-shto-value], [data-shto-off], [data-shto-value-wrap]').forEach(function (el) {
        if (el.closest('[data-shto-value-wrap]') && !el.hasAttribute('data-shto-value-wrap')) return;
        el.hidden = !hasValue;
      });
      var ok = !!(v && v.available);
      $$('[data-shto-add]').forEach(function (b) {
        b.setAttribute('data-id', v ? v.id : '');
        b.disabled = !ok;
        var t = b.querySelector('[data-shto-add-text]');
        if (t) t.textContent = ok ? buttonText : soldOutText;
      });
      setText('[data-shto-sticky-name]', c.name);
      setText('[data-shto-sticky-color]', v ? v.color : '');
      setText('[data-shto-sticky-variant]', c.name + (v ? ' · ' + v.color : ''));
      var photo = $('[data-shto-sticky-photo]');
      if (photo && c.photo && photo.getAttribute('src') !== c.photo) photo.setAttribute('src', c.photo);
      showAmount();
    }

    function selectChair(key) {
      var c = chairs[key];
      if (!c) return false;
      var old = variant();
      state.chair = key;
      var pick = null;
      if (old) c.variants.forEach(function (v) { if (!pick && v.available && v.color === old.color) pick = v; });
      c.variants.forEach(function (v) { if (!pick && v.available) pick = v; });
      pick = pick || c.variants[0];
      state.variant = pick ? pick.id : null;
      renderSwatches();
      update();
      if (!showColors()) showChairPhoto(key);
      return true;
    }
    // Each chair has its own photo in the gallery (a photo block with "Shows this chair"): picking the chair brings it up.
    function showChairPhoto(key) {
      var slide = track && track.querySelector('[data-shto-photo-chair="' + key + '"]');
      if (slide) goTo(Array.prototype.indexOf.call(track.children, slide));
    }

    root.addEventListener('click', function (e) {
      var card = e.target.closest('[data-shto-card]');
      if (card) { selectChair(card.getAttribute('data-shto-card')); return; }
      var sw = e.target.closest('[data-shto-swatches] .shto-chair-buy__swatch');
      if (sw && !sw.disabled) { state.variant = sw.getAttribute('data-id'); colorPicked = true; update(); showColors(); return; }
      var add = e.target.closest('[data-shto-add]');
      if (add) { addToCart(add); return; }
      var aff = e.target.closest('[data-shto-affirm]');
      if (aff) { openAffirm(); }
    });

    // Keyboard: arrow keys move between the chair cards (radio group).
    root.addEventListener('keydown', function (e) {
      var card = e.target.closest && e.target.closest('[data-shto-card]');
      if (!card || ['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft'].indexOf(e.key) < 0) return;
      var cards = $$('[data-shto-card]');
      var i = cards.indexOf(card) + (e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : -1);
      var next = cards[(i + cards.length) % cards.length];
      e.preventDefault();
      next.focus();
      selectChair(next.getAttribute('data-shto-card'));
    });

    // Any [data-shto-chair] link or button on the page (other sections' "Choose Max" buttons, the photo labels).
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('[data-shto-chair]');
      if (!link || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
      if (!selectChair(link.getAttribute('data-shto-chair'))) return;
      // On phones the buy box sits under the gallery: glide to the chair cards so the choice is seen.
      if (link.tagName === 'A' && link.getAttribute('href') === '#shto-buy' && window.innerWidth < 990) {
        var cardsTop = $('.shto-chair-buy__cards');
        var to = cardsTop ? cardsTop.previousElementSibling || cardsTop : root;
        e.preventDefault();
        e.stopPropagation(); // Prestige's own "#" handler (theme.js, on body) ignores preventDefault and would scroll to the section top
        var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: Math.max(0, Math.round(to.getBoundingClientRect().top + window.scrollY - headerBottom() - 16)), behavior: still ? 'auto' : 'smooth' });
      }
    }, true);

    // Add to cart
    var error = $('[data-shto-error]');
    function addToCart(btn) {
      var id = btn.getAttribute('data-id');
      if (!id || btn.disabled || btn.classList.contains('is-busy') || !window.ShtoCart) return;
      btn.classList.add('is-busy');
      if (error) error.hidden = true;
      window.ShtoCart.add([{ id: Number(id), quantity: 1 }]).catch(function (err) {
        if (error) { error.textContent = err && err.message ? err.message : ''; error.hidden = !error.textContent; }
      }).then(function () { btn.classList.remove('is-busy'); });
    }

    // Affirm
    var amountEl = $('[data-shto-affirm-amount]');
    var affirmCard = $('[data-shto-affirm]');
    function showAmount() {
      var c = current();
      if (amountEl && c) amountEl.textContent = c.amount || '​';
    }
    function readAmounts() {
      var done = true;
      Object.keys(chairs).forEach(function (k) {
        var c = chairs[k];
        var p = c.affirm && c.affirm.querySelector('.affirm-ala-price');
        if (p && p.textContent.trim()) c.amount = p.textContent.trim();
        else done = false;
      });
      showAmount();
      return done;
    }
    function openAffirm() {
      var c = current();
      var trigger = c && c.affirm && c.affirm.querySelector('.affirm-modal-trigger, a');
      if (trigger) trigger.click();
    }
    (function waitAffirm(tries) {
      if (window.affirm && window.affirm.ui && typeof window.affirm.ui.ready === 'function') {
        window.affirm.ui.ready(function () {
          try { window.affirm.ui.refresh(); } catch (e) {}
          var n = 0;
          (function poll() {
            if (readAmounts() || ++n > 60) {
              if (!current().amount && affirmCard && n > 60) affirmCard.hidden = true;
              return;
            }
            setTimeout(poll, 250);
          })();
        });
      } else if (tries < 100) setTimeout(function () { waitAffirm(tries + 1); }, 150);
      else if (affirmCard) affirmCard.hidden = true;
    })(0);

    // Gallery
    var track = $('[data-shto-track]');
    var index = $('[data-shto-index]');
    var thumbs = $$('[data-shto-thumb]');
    function slideCount() { return track ? track.children.length : 0; }
    function at() { return track && track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
    function goTo(i) {
      if (!track) return;
      var n = slideCount();
      i = (i + n) % n;
      var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({ left: i * track.clientWidth, behavior: still ? 'auto' : 'smooth' });
    }
    function showIndex() {
      var i = at();
      if (index) index.textContent = String(i + 1);
      thumbs.forEach(function (t, j) {
        t.classList.toggle('is-on', j === i);
        if (j === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      var on = thumbs[i], box = on && on.parentElement;
      if (on && box && getComputedStyle(on).display !== 'none') {
        var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var br = box.getBoundingClientRect(), tr = on.getBoundingClientRect();
        if (box.scrollWidth > box.clientWidth + 1) {
          var l = tr.left - br.left + box.scrollLeft, r = l + on.offsetWidth;
          if (l < box.scrollLeft || r > box.scrollLeft + box.clientWidth) box.scrollTo({ left: l - (box.clientWidth - on.offsetWidth) / 2, behavior: still ? 'auto' : 'smooth' });
        } else if (box.scrollHeight > box.clientHeight + 1) {
          var t0 = tr.top - br.top + box.scrollTop, b0 = t0 + on.offsetHeight;
          if (t0 < box.scrollTop || b0 > box.scrollTop + box.clientHeight) box.scrollTo({ top: t0 - (box.clientHeight - on.offsetHeight) / 2, behavior: still ? 'auto' : 'smooth' });
        }
      }
    }
    if (track) {
      var raf = 0;
      track.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; showIndex(); }); }, { passive: true });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(Number(t.getAttribute('data-shto-thumb'))); }); });
      var prev = $('[data-shto-prev]'), next = $('[data-shto-next]');
      if (prev) prev.addEventListener('click', function () { goTo(at() - 1); });
      if (next) next.addEventListener('click', function () { goTo(at() + 1); });
      window.addEventListener('resize', function () { track.scrollLeft = at() * track.clientWidth; });
    }

    // Colour photos
    var colorData = $('[data-shto-color-photos]');
    var colorChairs = colorData ? (colorData.getAttribute('data-chairs') || '').toLowerCase().split(',').map(function (k) { return k.trim(); }) : [];
    var colorShown = colorData ? colorData.getAttribute('data-current') || '' : '';
    var colorPicked = false; // colour photos only after the visitor has clicked a colour (never on load)
    var thumbBox = $('.shto-chair-buy__thumbs');
    var total = $('[data-shto-total]');
    function handleize(s) { return String(s || '').normalize('NFD').replace(/[\u0300-\u036f'’"]/g, '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
    function colorImg(src, srcset, sizes, alt) {
      var img = document.createElement('img');
      img.src = src; img.srcset = srcset; img.sizes = sizes; img.alt = alt; img.decoding = 'async';
      return img;
    }
    // Returns true when colour photos are showing (and the first one is brought up).
    function showColors() {
      if (!track || !colorData) return false;
      var v = variant();
      var want = colorPicked && v && colorChairs.indexOf(state.chair) >= 0 ? handleize(v.color) : '';
      var list = want ? Array.prototype.filter.call(colorData.children, function (li) { return li.getAttribute('data-color') === want; }) : [];
      if (!list.length) want = '';
      if (want !== colorShown) {
        $$('[data-shto-color-slide], [data-shto-color-thumb]').forEach(function (el) { el.parentNode.removeChild(el); });
        var firstSlide = track.firstElementChild, firstThumb = thumbBox && thumbBox.firstElementChild;
        list.forEach(function (li, n) {
          var slide = document.createElement('div');
          slide.className = 'shto-chair-buy__slide';
          slide.setAttribute('data-shto-color-slide', '');
          var img = colorImg(li.getAttribute('data-src'), li.getAttribute('data-srcset'), colorData.getAttribute('data-sizes'), li.getAttribute('data-alt') || '');
          img.className = 'shto-chair-buy__slide-img'; img.width = 1400; img.height = 1400;
          slide.appendChild(img);
          track.insertBefore(slide, firstSlide);
          if (!thumbBox) return;
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'shto-chair-buy__thumb';
          b.setAttribute('data-shto-color-thumb', '');
          b.setAttribute('data-shto-thumb', '');
          b.setAttribute('aria-label', (colorData.getAttribute('data-slide-label') || '') + ' ' + (n + 1));
          var t = colorImg(li.getAttribute('data-thumb'), li.getAttribute('data-thumb-srcset'), colorData.getAttribute('data-thumb-sizes'), '');
          t.width = 496; t.height = 496; t.loading = 'lazy';
          b.appendChild(t);
          b.addEventListener('click', function () { goTo(Number(b.getAttribute('data-shto-thumb'))); });
          thumbBox.insertBefore(b, firstThumb);
        });
        colorShown = want;
        thumbs = $$('[data-shto-thumb]');
        thumbs.forEach(function (t, j) {
          t.setAttribute('data-shto-thumb', String(j));
          if (t.hasAttribute('data-shto-color-thumb')) return;
          t.setAttribute('aria-label', t.getAttribute('aria-label').replace(/\d+$/, String(j + 1)));
        });
        if (total) total.textContent = String(slideCount());
        track.scrollLeft = 0;
        showIndex();
      }
      if (want) goTo(0);
      return !!want;
    }

    // Sticky bar
    var sticky = $('[data-shto-sticky]');
    var mainButton = $('.shto-chair-buy__box [data-shto-add]');
    var shown = false;
    function checkSticky() {
      if (!sticky || !mainButton) return;
      var r = mainButton.getBoundingClientRect();
      var show = r.bottom < headerBottom() && r.height > 0;
      if (show === shown) return;
      shown = show;
      sticky.classList.toggle('is-shown', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
    }

    var stickyRaf = 0;
    function onScroll() { if (!stickyRaf) stickyRaf = requestAnimationFrame(function () { stickyRaf = 0; checkSticky(); }); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    checkSticky();

    // Countdown
    var clocks = $$('[data-shto-timer]');
    var cds = $$('[data-shto-cd]');
    var minutes = Number(root.getAttribute('data-timer-minutes')) || 139;
    var KEY = 'shto-chair-timer-end';
    // Same as the countdown on relaxe.co/pages/shiatsu-chair (Instant): it starts at the set minutes on the visitor's first view,
    // is kept for the browser tab's session (sessionStorage), and stops at 00 : 00 : 00.
    function nextMidnight() { var d = new Date(); d.setDate(d.getDate() + 1); d.setHours(0, 0, 0, 0); return d.getTime(); } var end = nextMidnight(); // matches header announce-timer (midnight)
    // rolls over at midnight in tick()
    var timerId = 0;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      if (end - Date.now() <= 0) end = nextMidnight(); var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var text = pad(Math.floor(left / 3600)) + ' : ' + pad(Math.floor(left / 60) % 60) + ' : ' + pad(left % 60);
      clocks.forEach(function (c) { c.textContent = text; });
      cds.forEach(function (c) {
        var k = c.getAttribute('data-shto-cd');
        c.textContent = pad(k === 'h' ? Math.floor(left / 3600) : k === 'm' ? Math.floor(left / 60) % 60 : left % 60);
      });
      // keeps running past midnight
    }
    if (clocks.length || cds.length) { tick(); timerId = setInterval(tick, 1000); }

    // Total Value (i): opens the explanation, as the (i) on relaxe.co/pages/shiatsu-chair does.
    var dialog = $('[data-shto-value-dialog]');
    if (dialog && dialog.showModal) {
      root.addEventListener('click', function (e) {
        if (e.target.closest('[data-shto-value-info]')) { dialog.showModal(); return; }
        if (e.target.closest('[data-shto-dialog-close]') || e.target === dialog) dialog.close();
      });
    }

    update();
  }

  function initAll(scope) { (scope || document).querySelectorAll('[data-shto-chair-buy]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
